import { Router } from '../routes';

const replaceRoute = (route, query, options) => Router.replaceRoute(
  route, query, { scroll: false, ...options },
);

export default replaceRoute;
